import type { FC } from 'react'

import type { HoldingWeekDto } from '@hcr/api/consumer'

import { NonVillaWeeksPreview } from './non-villa-weeks-preview'
import { VillaWeeksPreview } from './villa-weeks-preview'

interface WeeksPreviewProps {
  holdingId: string
  isVilla: boolean
  weeks: HoldingWeekDto[]
}

export const WeeksPreview: FC<WeeksPreviewProps> = ({ weeks, isVilla, holdingId }) => {
  if (isVilla) {
    return <VillaWeeksPreview weeks={weeks} holdingId={holdingId} />
  }
  return <NonVillaWeeksPreview weeks={weeks} holdingId={holdingId} />
}
